import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-open",
  "use": "oc-open-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-open\"><path fill=\"#696F7C\" d=\"m20.046 9.984 2.544 3.01-2.543 3.02-1.53-1.287.61-.727H5.41v-2h13.722l-.614-.725 1.528-1.291ZM20.41 5.5v2h-15v-2h15Zm0 13v2h-15v-2h15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol